import React, { useEffect, useRef } from "react";
import * as XLSX from "@lokalise/xlsx";

const GlobalDropZone = ({ updateAlert, handleFileUpload, requiredColumns }) => {
  const dropRef = useRef();

  const isValidExtension = (fileName) => {
    const allowedExtensions = [".xlsx", ".xls", ".csv"];
    return allowedExtensions.some((ext) =>
      fileName.toLowerCase().endsWith(ext)
    );
  };

  const isValidStructure = (columns) => {
    return Object.keys(requiredColumns).every((col) => columns.includes(col));
  };

  useEffect(() => {
    const handleDragOver = (e) => {
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
      dropRef.current.style.border = "2px dashed #0f62fe";
      dropRef.current.style.background = "#f0f8ff";
    };

    const handleDragLeave = () => {
      dropRef.current.style.border = "none";
      dropRef.current.style.background = "transparent";
    };

    const handleDrop = (e) => {
      e.preventDefault();
      dropRef.current.style.border = "none";
      dropRef.current.style.background = "transparent";

      const file = e.dataTransfer.files[0];
      if (!file) return;

      if (!isValidExtension(file.name)) {
        updateAlert({
          open: true,
          message: "Invalid file format. Please upload an Excel or CSV file.",
          severity: "Failed",
          closeFlag: true,
        });
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });

          const sheet = workbook.Sheets[workbook.SheetNames[0]];
          const json = XLSX.utils.sheet_to_json(sheet, { defval: "" });

          if (json.length === 0) {
            updateAlert({
              open: true,
              message: "The uploaded file is empty.",
              severity: "Failed",
              closeFlag: true,
            });
            return;
          }

          const fileColumns = Object.keys(json[0]);
          if (!isValidStructure(fileColumns)) {
            updateAlert({
              open: true,
              message: "Invalid file structure.",
              severity: "Failed",
              closeFlag: true,
            });
            return;
          }

          // Callback to parent
          handleFileUpload(json);
        } catch (err) {
          updateAlert({
            open: true,
            message: "Error reading file. Please try again.",
            severity: "Failed",
            closeFlag: true,
          });
        }
      };
      reader.readAsArrayBuffer(file);
    };

    window.addEventListener("dragover", handleDragOver);
    window.addEventListener("dragleave", handleDragLeave);
    window.addEventListener("drop", handleDrop);

    return () => {
      window.removeEventListener("dragover", handleDragOver);
      window.removeEventListener("dragleave", handleDragLeave);
      window.removeEventListener("drop", handleDrop);
    };
  }, [handleFileUpload]);

  return (
    <div
      ref={dropRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 9999,
        pointerEvents: "none", // keeps it transparent to clicks
      }}
    />
  );
};

export default GlobalDropZone;
